import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminSettings = (args, config) => {
    return useQuery({
        queryKey: ['admin', 'setting', 'get', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/admin/settings`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiSearchAdminSmsHistory = (args) => {
    return useQuery({
        queryKey: ['admin', 'setting', 'get', 'sms-history', args],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/sms/history`, {params: config})
        })(args)),
    })
}


export function useApiCreateAdminSetting() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/settings`, data)
            })(data))
    });
}
